// extracted by mini-css-extract-plugin
module.exports = {"container":"ToggleGroup_container__3X5p3","option":"ToggleGroup_option__2sxWs","option--active":"ToggleGroup_option--active__1Dk7E"};